// extracted by mini-css-extract-plugin
export default {"wrapper":"StandardAppLayout_wrapper__QQK+j","main":"StandardAppLayout_main__EeEKI"};